/**
 * Adresse de la fiche « Prospect & entreprise ».
 *
 * La liste fait une fiche par établissement (SIRET), mais une même personne
 * peut représenter plusieurs établissements sous un seul e-mail : l'e-mail
 * seul mène alors toujours au même. Le SIRET, quand la fiche est celle d'un
 * professionnel, désigne lequel ; il va dans le chemin (et non en paramètre)
 * pour que la vue se recharge d'un établissement à l'autre.
 */
export function contactDetailPath(email, siret = null) {
  if (!email) return null
  const base = `/contacts/${encodeURIComponent(email)}`
  const digits = siretDigits(siret)
  return digits ? `${base}/${digits}` : base
}

/**
 * Adresse de la même fiche vue depuis la liste « Entreprises » : un
 * établissement a toujours un SIRET ; sans lui, il n'y a pas de fiche
 * entreprise à ouvrir.
 */
export function entrepriseDetailPath(email, siret) {
  const digits = siretDigits(siret)
  if (!email || !digits) return null
  return `/entreprises/${encodeURIComponent(email)}/${digits}`
}

/**
 * Même adresse, à partir d'un contact ou d'une demande (champs de l'API).
 */
export function contactDetailPathOf(record) {
  if (!record) return null
  return contactDetailPath(record.email, ficheSiretOf(record))
}

/**
 * SIRET qui désigne la fiche d'un contact ou d'une demande : celui d'un
 * professionnel seulement, la fiche d'un particulier n'en dépend pas.
 */
export function ficheSiretOf(record) {
  return record?.client_type === 'professionnel' ? siretDigits(record.professionnel_siret) : ''
}

/**
 * Paramètre d'URL des appels API de la fiche. La fiche d'une personne (vue
 * depuis Contacts) réunit toutes ses demandes, quel que soit l'établissement :
 * elle ne transmet aucun SIRET.
 */
export function contactFicheQuery(siret, perimetre = null) {
  if (perimetre) return `?perimetre=${perimetre}`
  const digits = siretDigits(siret)
  return digits ? `?siret=${digits}` : ''
}

export const PERIMETRE_PERSONNE = 'personne'

function siretDigits(siret) {
  return siret ? String(siret).replace(/\D/g, '') : ''
}
